import { render } from "./Ready.vue?vue&type=template&id=bfe7277c&scoped=true"
import script from "./Ready.vue?vue&type=script&lang=js"
export * from "./Ready.vue?vue&type=script&lang=js"

import "./Ready.vue?vue&type=style&index=0&id=bfe7277c&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe7277c"]])

export default __exports__